module.exports = __webpack_public_path__ + "static/fgr-live-video-f4d3bc9d033defbd2673bcbc3fb910b1.jpg";